"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDdi = void 0;
var react_1 = __importStar(require("react"));
var Botao_1 = require("../../../Botao/Botao");
var Cores_1 = require("../../../Cores/Cores");
var GradacaoNeutros_1 = __importDefault(require("../../../Cores/GradacaoNeutros "));
var HelperText_1 = require("../../../HelperText/HelperText");
var Icone_1 = require("../../../Icone/Icone");
var globalMu_1 = __importDefault(require("../../../../globalMu"));
var Label_1 = require("../../../Label/Label");
var listaCodigoInternacionalTelefone_1 = require("./listaCodigoInternacionalTelefone");
var MenuDDI_1 = require("../../../Menu/MenuDDI/MenuDDI");
var Bandeiras_1 = require("../../../../assets/flags/Bandeiras");
var InputDdiModule = require("./InputDdi.module.scss");
var InputDdi = function (_a) {
    var _b;
    var id = _a.id, name = _a.name, valorInicial = _a.valorInicial, itemSelecionado = _a.itemSelecionado, manterMenuAberto = _a.manterMenuAberto, _c = _a.placeholder, placeholder = _c === void 0 ? "Selecione uma opção" : _c, titulo = _a.titulo, conteudoDeAjuda = _a.conteudoDeAjuda, _d = _a.estilo, estilo = _d === void 0 ? "regular" : _d, _e = _a.tamanho, tamanho = _e === void 0 ? "small" : _e, _f = _a.desabilitado, desabilitado = _f === void 0 ? false : _f, menuProps = _a.menuProps, _g = _a.opcoesMenu, opcoesMenu = _g === void 0 ? listaCodigoInternacionalTelefone_1.listaCodigoInternacionalTelefone : _g, botaoDeLimpar = _a.botaoDeLimpar, style = _a.style, onChange = _a.onChange, regraTexto = _a.regraTexto;
    var _h = (0, react_1.useState)(valorInicial ? regraTexto(valorInicial) : null), valor = _h[0], setValor = _h[1];
    var _j = (0, react_1.useState)([]), sugestoes = _j[0], setSugestoes = _j[1];
    var _k = (0, react_1.useState)(false), openSelectMenu = _k[0], setOpenSelectMenu = _k[1];
    var _l = (0, react_1.useState)(null), selecionado = _l[0], setSelecionado = _l[1];
    var selectStyle = InputDdiModule[estilo] || "";
    var selectSize = InputDdiModule[tamanho] || "";
    var selectDisabledStyle = desabilitado ? InputDdiModule["disabled"] : "";
    var selectClasses = "".concat(InputDdiModule.select, " ").concat(selectStyle, " ").concat(selectSize, " ").concat(selectDisabledStyle);
    var selectRef = (0, react_1.useRef)(null);
    var gapStyle = titulo || conteudoDeAjuda ? "12px" : "0";
    //#region Métodos
    var onSelect = function (item) {
        if (item === null) {
            setValor(null);
            setSugestoes(opcoesMenu);
        }
        else
            setValor(regraTexto(item));
        manterMenuAberto ? setOpenSelectMenu(true) : setOpenSelectMenu(false);
        onChange && onChange(item !== null ? item : null);
    };
    var toggleMenu = function () {
        !desabilitado && setOpenSelectMenu(function (current) { return !current; });
    };
    var handleClear = function () {
        setSugestoes(opcoesMenu);
        setOpenSelectMenu(false);
        onChange && onChange(null);
        setValor(null);
    };
    var handleChange = function (event) {
        setValor(event.target.value);
    };
    //#region Componentes
    var ValorSelecionado = (react_1.default.createElement("input", { className: "".concat(InputDdiModule.input, " ").concat(selectStyle), value: valor !== null && valor !== void 0 ? valor : "", placeholder: placeholder, readOnly: true, disabled: desabilitado, autoComplete: "off", name: name, id: id, onChange: handleChange, onEmptied: handleClear, onFocus: function () { return setOpenSelectMenu(true); } }));
    var BotaoExpandaMais = (react_1.default.createElement("div", { onClick: function () { return toggleMenu(); }, className: "\n            ".concat(InputDdiModule.selectIcon, "\n            ").concat(selectStyle, "\n            ").concat(selectDisabledStyle, "\n        ") },
        react_1.default.createElement(Icone_1.Icone, { nome: openSelectMenu ? "expand_less" : "expand_more", altura: "20px", largura: "20px", desabilitado: desabilitado, cor: GradacaoNeutros_1.default.CinzaFillMU600, corOnHover: Cores_1.Cores.GradacaoPrimaria.AzulMU500 })));
    var BotaoLimpar = (react_1.default.createElement(Botao_1.Botao, { desabilitado: desabilitado, onClick: function () { return handleClear(); }, estilo: "ghost", exibirBotaoArrendondado: true, tamanho: "xsmall", tipo: "tipoIconRound" },
        react_1.default.createElement(Icone_1.Icone, { nome: "close", altura: "16px", desabilitado: desabilitado, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU })));
    var bandeiraValorSelecionado = (react_1.default.createElement(Bandeiras_1.Bandeiras, { Altura: "20px", Largura: "40px", bandeira: (_b = selecionado === null || selecionado === void 0 ? void 0 : selecionado.bandeira) !== null && _b !== void 0 ? _b : undefined, style: { display: "".concat((selecionado === null || selecionado === void 0 ? void 0 : selecionado.bandeira) ? "block" : "none") } }));
    var SelectInput = (react_1.default.createElement("div", { ref: selectRef, className: selectClasses },
        bandeiraValorSelecionado,
        ValorSelecionado,
        botaoDeLimpar &&
            globalMu_1.default.isNotNullOrEmptyOrUndefined(valor) &&
            !desabilitado &&
            BotaoLimpar,
        BotaoExpandaMais,
        openSelectMenu && (react_1.default.createElement("div", { className: "\n                    ".concat(InputDdiModule.menu, "\n                    ").concat(InputDdiModule[(menuProps === null || menuProps === void 0 ? void 0 : menuProps.posicaoDoMenu) || "below"], "\n                    ").concat(selectStyle, "\n                ") },
            react_1.default.createElement(MenuDDI_1.MenuDDI, __assign({ id: "".concat(id, "-menuDDi"), key: "".concat(id, "-menuDDi"), style: menuProps === null || menuProps === void 0 ? void 0 : menuProps.style, opcoesMenu: globalMu_1.default.isNotNullOrEmptyOrUndefined(sugestoes)
                    ? sugestoes
                    : opcoesMenu, itemSelecionado: selecionado, onSelect: onSelect, regraTexto: regraTexto, quebrarLinhas: true, esconderTextoExtenso: true, estilo: estilo }, menuProps))))));
    var Titulo = react_1.default.createElement(Label_1.Label, __assign({}, titulo));
    var Conteudoajuda = (react_1.default.createElement(HelperText_1.HelperText, { texto: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.texto) || "", estado: (conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.estado) || estilo, desabilitado: desabilitado, icone: conteudoDeAjuda === null || conteudoDeAjuda === void 0 ? void 0 : conteudoDeAjuda.icone }));
    //#region UseEffects
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (selectRef.current &&
                !selectRef.current.contains(event.target)) {
                setOpenSelectMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", function (event) {
                return handleClickOutside(event);
            });
        };
    }, [selectRef]);
    (0, react_1.useEffect)(function () {
        setValor(valorInicial ? regraTexto(valorInicial) : null);
    }, [valorInicial]);
    (0, react_1.useEffect)(function () {
        var _a;
        setSelecionado((_a = opcoesMenu.find(function (item) { return regraTexto(item) === valor; })) !== null && _a !== void 0 ? _a : null);
    }, [valor]);
    (0, react_1.useEffect)(function () {
        setSugestoes(opcoesMenu);
    }, [opcoesMenu, valor]);
    (0, react_1.useEffect)(function () {
        setSelecionado(itemSelecionado || valorInicial || null);
    }, [valorInicial, itemSelecionado]);
    //#region Render
    return (react_1.default.createElement("div", { className: "".concat(InputDdiModule.container), style: __assign(__assign({}, style), { gap: gapStyle }) },
        titulo && Titulo,
        SelectInput,
        conteudoDeAjuda && Conteudoajuda));
};
exports.InputDdi = InputDdi;
